// Admin-configured defaults for the four built-in Deal Flow statuses: name, colour and icon.
// Admin Settings > Deal Flow Statuses owns them; the values below are only used until the
// first load finishes, so the board never renders blank.
const FALLBACK = {
    invited: { label: 'New', color: '#87909E', icon: 'inbox' },
    interested: { label: 'Shortlisted', color: '#F8AE00', icon: 'star' },
    'in-progress': { label: 'Selected', color: '#1090E0', icon: 'handshake' },
    rejected: { label: 'Rejected', color: '#C62A2F', icon: 'cancel' },
};

let current = FALLBACK;

export const setStatusDefaults = (statuses) => {
    if (statuses && typeof statuses === 'object') current = { ...FALLBACK, ...statuses };
};

export const getStatusDefaults = () => current;

// The name an investor sees. A status they renamed keeps their name; otherwise the admin default applies.
// Works on the raw API row (`value` is the fixed key) and on the mapped row (`mappedValue` is).
export const resolveStatusLabel = (status) => {
    const key = status?.mappedValue ?? status?.value;
    const fallbackName = status?.status ?? status?.label;
    const def = getStatusDefaults()[key];
    if (def && !status?.label_customized) return def.label;
    return fallbackName;
};
